import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Grid } from "@material-ui/core";
import { useSelector } from "react-redux";

import { endpoint } from "assets/api/endpoint";
import { apiHandler } from "assets/api";

import CircularProgresss from "components/CircularProgress/CircularProgresss";
import SubHeader from "components/UpdateUi/SubHeader/SubHeader";
import CustomeTextField from "components/UpdateUi/CustomeTextField";
import CustomSelectNew from "components/UpdateUi/CustomeSelect";
import ToastModal from "views/components/ToastModal";
import { replaceValueToCode } from "utils/Utils";

const MasterItemCreate = ({ classes }) => {
  const navigate = useNavigate();
  const params = useParams();

  const { authToken } = useSelector(
    (state) => state.login.authData
  );

  const [categoryId, setCategoryId] = useState(params?.categoryId || "");
  const [categoryList, setCategoryList] = useState([]);

  const [codeState, setCodeState] = useState(false);

  const [value, setValue] = useState("");
  const [valueState, setValueState] = useState(false);

  const [disabledButton, setDisabledButton] =
    useState(true);

  const [toast, setToast] = useState(false);
  const [toastMessage, setToastMessage] =
    useState("");
  const [toastMessageType, setToastMessageType] =
    useState("");

  const [callInProgress, setCallInProgress] =
    useState(false);

  // Get Category List
  const getCategoryList = async () => {
    const result = await apiHandler({
      url: endpoint.MASTER_CATEGORY_FIND_BY_ID  + params?.categoryId,
      authToken,
    });
      setCategoryList([result.data]);
      await getEditData();
  };

  // Edit Data
  const getEditData = async () => {
    if (!params?.id) return;

    setCallInProgress(true);

    const result = await apiHandler({
      url: endpoint.MASTER_CATEGORY_ITEM_FINDALL,
      authToken,
    });

    setCallInProgress(false);

    const filteredData = result?.data?.filter(
      (item) => item?.id === Number(params?.id)
    );

    if (filteredData?.length > 0) {
      const data = filteredData[0];

      setCategoryId(data?.categoryId || "");
      setValue(data?.value || "");
    }
  };

  useEffect(() => {
    getCategoryList();
  }, []);

  useEffect(() => {
    if (categoryId && value) {
      setDisabledButton(false);
    } else {
      setDisabledButton(true);
    }
  }, [categoryId, value]);

  const toastUpdate = (
    type,
    message,
    showToast
  ) => {
    setToastMessageType(type);
    setToastMessage(message);
    setToast(showToast);
  };

  // Update API
  const editInformation = async () => {
    setCallInProgress(true);

    const res = await apiHandler({
      url: endpoint.MASTER_CATEGORY_ITEM_UPDATE + params?.id,
      method: "PUT",
      authToken,
      data: {
        categoryId,
        code:replaceValueToCode(value),
        value,
      },
    });

    setCallInProgress(false);

    if (res?.data?.error_code) {
      toastUpdate(
        "Error",
        res?.data?.user_description,
        true
      );
      return "ERROR";
    }

    return "SUCCESS";
  };

  // Create API
  const saveInformation = async () => {
    setCallInProgress(true);

    const res = await apiHandler({
      url: endpoint.MASTER_CATEGORY_ITEM_CREATE,
      method: "POST",
      authToken,
      data: {
        categoryId,
        code: replaceValueToCode(value),
        value,
      },
    });

    setCallInProgress(false);

    if (res?.data?.error_code) {
      toastUpdate(
        "Error",
        res?.data?.user_description,
        true
      );
      return "ERROR";
    }

    return "SUCCESS";
  };

  // Submit
  const handleDiscrepancySubmit = async () => {
    let status = "";

    if (params?.id) {
      status = await editInformation();
    } else {
      status = await saveInformation();
    }

    if (status === "SUCCESS") {
      toastUpdate(
        "Success",
        params?.id
          ? "Master Item updated successfully!"
          : "Master Item created successfully!",
        true
      );

      navigate(`/coreservice/MasterItem/${params?.name}/${categoryId}/`);
    }
  };
  // Cancel
  const handleCancel = () => {
    navigate(`/coreservice/MasterItem/${params?.name}/${categoryId}/`);
  };
  const handleChange = (e)=>{
    setValue(e)
  }
  return (
    <Grid container>
      <Grid item xs={12}>
        <SubHeader
          label={
            params?.id
              ? "Edit Master Item"
              : "Create Master Item"
          }
          button1="Save"
          button2="Cancel"
          button1click={handleDiscrepancySubmit}
          button2click={handleCancel}
          disabled1={disabledButton}
        />
      </Grid>

      <Grid
        item
        xs={12}
        className={classes.inputContainer}
      >
        <Grid
          container
          spacing={2}
          className={classes.inputFieldContainer}
        >
          <Grid
            item
            xs={12}
            sm={6}
            md={4}
            className={classes.fieldContaienr}
          >
            <CustomSelectNew
              label="Category"
              id="categoryId"
              value={categoryId}
              setState={setCategoryId}
              data={categoryList}
              type="value"
              disabled={true}
            />
          </Grid>

          {/* Value */}
          <Grid
            item
            xs={12}
            sm={6}
            md={4}
            className={classes.fieldContaienr}
          >
            <CustomeTextField
              label="Name"
              required
              error={valueState}
              id="value"
              value={value}
              setState={handleChange}
              setError={setValueState}
              type="notCapital"
            />
          </Grid>
        </Grid>
      </Grid>

      {toast && (
        <ToastModal
          toastMessage={toastMessage}
          toastMessageType={toastMessageType}
          toastUpdate={toastUpdate}
        />
      )}

      {callInProgress && (
        <CircularProgresss
          callInProgress={callInProgress}
        />
      )}
    </Grid>
  );
};

export default MasterItemCreate;